<template>
  <div class="fixed left-0 top-0 z-40 w-full bg-white py-8">
    <!-- Top gradient -->
    <div class="absolute inset-x-0 top-0 z-40 h-2 w-full bg-gradient-nav xl:h-3" />

    <!-- DESKTOP -->
    <Container use-full-width class="flex items-end justify-between gap-10 max-xl:hidden">
      <!-- LOGO -->
      <NuxtLink
        :to="localePath('/')"
        :aria-label="$t('aria_labels.home')"
      >
        <IconWetrokLogo class="h-14" />
      </NuxtLink>

      <div>
        <!-- META NAVIGATION -->
        <MetaNavigation class="" />

        <!-- MAIN NAVIGATION -->
        <MainNavigation />
      </div>
    </Container>

    <!-- MOBILE -->
    <NavigationMobile class="xl:hidden" />
  </div>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
const localePath = useLocalePath()
</script>
